import FeatherIconWrapper from "../Icons/FeatherIconWrapper";
import {WerfenColorMid, WerfenFormFieldColor, WerfenFormTextColor, White} from "../../Constants/ColorChart";
import UserIcon from "../Icons/User/User";
import React, {ChangeEvent, KeyboardEvent} from "react";
import styled from "styled-components";


const StyledInput = styled.input`
  border: none;
  width: 100%;
  font-size: 15pt;
  background: ${props => props.background ? props.background : WerfenColorMid};
  color: ${props => props.color ? props.color : White};
  padding-left: 2%;
  padding-right: 2%;
  height: 50px;
  display: inline-block;
  margin-right: 0;
  ${props => props.extraStyle && props.extraStyle};
  &::placeholder {
    color: ${props => props.color ? props.color : White};
  }
  &:focus {
    outline: none;
  }
`;

type LoginUsernameProps = {
    user: string;
    handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
    handleKeyPress: (event: KeyboardEvent<HTMLInputElement>) => void;
};

const LoginUsername: React.FC<LoginUsernameProps> = ({user, handleChange, handleKeyPress}) => {
    return (
        <div>
            <FeatherIconWrapper
                color={WerfenFormTextColor}
                width="30px"
                iconStyle="stroke-width: 1.5px; margin-left: 10px; margin-top: 10px; width: 30px; height: 30px; position: absolute;"
                Icon={UserIcon}
            />
            <StyledInput
                placeholder="Username"
                value={user}
                onChange={handleChange}
                background={WerfenFormFieldColor}
                color={WerfenFormTextColor}
                extraStyle="padding-left: 50px;"
                onKeyUp={handleKeyPress}
            />
        </div>
    );
};

export default LoginUsername;